import '@fontsource/barlow/400.css';
import '@fontsource/barlow/500.css';
import '@fontsource/barlow/700.css';
import '@fontsource/barlow-condensed/400.css';
import '@fontsource/barlow-condensed/600.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/animations.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { createApp, createServices } from './app/composition';
import { AppProvider } from './app/AppProvider';
import { startTicker } from './app/store';
import { loadConfig } from './config';

const config = loadConfig(import.meta.env);
const { store, services } = createApp(config, createServices(config, import.meta.env.DEV));
startTicker(store.dispatch);

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <AppProvider
      store={store}
      config={config}
      audio={services.audio}
      robot={services.robot}
      sync={services.sync}
      setup={services.setup}
      updates={services.updates}
    >
      <App />
    </AppProvider>
  </StrictMode>,
);
